// Navigation for large AI proposals: Previous/Next by window, numbered day buttons, date jump.
// Only changes which days are visible; the draft itself lives in ScheduleProposal.
import React, { useEffect, useRef } from 'react';
import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

export const windowFor = (index, size, total) => Math.max(0, Math.min(Math.floor(index / size) * size, Math.max(0, total - 1)));

export default function ProposalDayNav({ days, start, size, dateOf, flagged = new Set(), onStart, label='Proposed shooting days' }) {
  const strip = useRef(null);
  useEffect(() => { strip.current?.querySelector('[aria-current="true"]')?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' }); }, [start]);
  if (!days.length) return null;
  const dates = new Map(days.map((d, i) => [dateOf(d.dayNumber), i]).filter(([k]) => k));
  const last = days.length - 1;
  return <nav className="pp-sched-ai-nav" aria-label={label}>
    <Button size="small" icon={<MdChevronLeft />} disabled={start === 0} onClick={() => onStart(Math.max(0, start - size))} aria-label="Previous days">Previous</Button>
    <div className="pp-sched-ai-nav-days" ref={strip}>
      {days.map((d, i) => <Button size="small" key={d.dayNumber} aria-current={i >= start && i < start + size ? 'true' : undefined}
        aria-label={`Show Day ${d.dayNumber}`} className={flagged.has(d.dayNumber) ? 'is-flagged' : ''} onClick={() => onStart(windowFor(i, size, days.length))}>{d.dayNumber}</Button>)}
    </div>
    <Button size="small" disabled={start + size > last} onClick={() => onStart(Math.min(last, start + size))} aria-label="Next days">Next <MdChevronRight /></Button>
    {dates.size > 0 && <DatePicker size="small" aria-label="Jump to date" placeholder="Jump to date" allowClear={false} inputReadOnly
      disabledDate={d => !dates.has(d.format('YYYY-MM-DD'))} defaultPickerValue={dayjs(dateOf(days[start]?.dayNumber) || undefined)}
      onChange={d => d && dates.has(d.format('YYYY-MM-DD')) && onStart(windowFor(dates.get(d.format('YYYY-MM-DD')), size, days.length))} />}
  </nav>;
}
